"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerLinks = void 0;
var headerLinks = [{
  name: "O nas",
  url: "/about-us"
}, {
  name: "Obsługa klienta",
  url: "/contact"
}];
exports.headerLinks = headerLinks;